import { render, staticRenderFns } from "./title-icon.vue?vue&type=template&id=8fb092ba&scoped=true"
import script from "./title-icon.vue?vue&type=script&lang=js"
export * from "./title-icon.vue?vue&type=script&lang=js"
import style0 from "./title-icon.vue?vue&type=style&index=0&id=8fb092ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb092ba",
  null
  
)

export default component.exports